import { Injectable, inject } from '@angular/core';
import { DatePicker, DateRange } from '@com-delta-omnichannel/mach-core-js';
import { WidgetEventService } from '../../shared/utils/widget-event.service';
import { Vacation_Date_Config } from '../constants/vacation-widget.constants';
import { VacationWidget } from '../models/vacation-widget.interfaces';
@Injectable({
  providedIn: 'root'
})
export class DateManagementService {
  private eventService = inject(WidgetEventService);

  setupDateChangeListener(
    rangeDatePickerInstance: DatePicker,
    content: VacationWidget,
    onCloseFn?: () => void
  ): void {
    rangeDatePickerInstance.onChange(() => {
      this.updateDateDisplay(rangeDatePickerInstance, content);
    });

    rangeDatePickerInstance.onClose(() => {
      onCloseFn?.();
      if (content.dropDownDateOption.triggerElementId) {
        document
          .getElementById(content.dropDownDateOption.triggerElementId)
          ?.focus();
      }
    });
  }

  updateDateDisplay(
    rangeDatePickerInstance: DatePicker,
    content: VacationWidget
  ): void {
    const displaySpan = document.querySelector(
      '.vacation-widget__date-text'
    ) as HTMLElement;
    if (!displaySpan) return;

    const selectedDates: DateRange =
      rangeDatePickerInstance?.getSelectedDates();

    if (this.hasValidDates(selectedDates)) {
      this.updateDisplayWithDates(displaySpan, selectedDates, content);
      this.eventService.emitDateChange(selectedDates);
      this.eventService.emitDateError();
    } else {
      this.updateDisplayWithDates(displaySpan, selectedDates, content);
      this.eventService.emitDateChange(selectedDates);
    }
    this.eventService.emitErrorCountChange();
  }

  private hasValidDates(dates: DateRange): boolean {
    return !!(
      dates?.start &&
      dates?.end &&
      dates.start.getTime() > 0 &&
      dates.end.getTime() > 0
    );
  }

  private updateDisplayWithDates(
    displaySpan: HTMLElement,
    dates: DateRange,
    content: VacationWidget
  ): void {
    let startFormatted = content.labels.startDate;
    if (dates.start)
      startFormatted = dates.start.toLocaleDateString(
        Vacation_Date_Config.locale,
        {
          month: Vacation_Date_Config.month,
          day: Vacation_Date_Config.day,
          timeZone: Vacation_Date_Config.timezone
        }
      );
    let endFormatted = content.labels.endDate;
    if (dates.end)
      endFormatted = dates.end.toLocaleDateString(Vacation_Date_Config.locale, {
        month: Vacation_Date_Config.month,
        day: Vacation_Date_Config.day,
        timeZone: Vacation_Date_Config.timezone
      });
    displaySpan.textContent = `${startFormatted} - ${endFormatted}`;
    displaySpan.classList.add('text-heading', 'text-label-md-medium');
    displaySpan.classList.remove(
      'text-subtle',
      'whitespace-nowrap',
      'laptop:max-w-[126px]',
      'laptop:overflow-hidden',
      'laptop:text-ellipsis',
      'ultrawide:max-w-none'
    );
  }
}
